import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox, Stack } from '@ardoq/layout';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { updateViewSettings } from '@ardoq/view-settings';
import { t, Trans, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { ViewIds } from '@ardoq/api-types';

type NoDataWithShowEmptyValuesDoqProps = {
  doqType: DoqType;
  viewId: ViewIds.COMPONENT_MATRIX_2;
  includeActions?: boolean;
  i18nLocale: I18nLocale;
};

const NoDataWithShowEmptyValuesDoqBase = ({
  doqType,
  viewId,
  includeActions = true,
  i18nLocale,
}: NoDataWithShowEmptyValuesDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDataWithShowEmptyValues.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDataWithShowEmptyValues.message1',
                'There are only empty values from these row and column groupings.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              <span style={{ display: 'inline' }}>
                <Trans
                  i18nKey="tabview:graphViews.emptyState.noDataWithShowEmptyValues.message2"
                  defaults='To show more data, activate the view modifier "<icon/>"'
                  components={{
                    icon: (
                      <Icon
                        iconSize={IconSize.SMALL}
                        iconName={IconName.NOT_INTERESTED}
                      />
                    ),
                  }}
                />
              </span>
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:componentMatrix.leftMenu.showNoValue',
                'Show no value'
              )
            : undefined
        }
        onButtonClick={
          includeActions
            ? () =>
                dispatchAction(
                  updateViewSettings({
                    viewId,
                    settings: { showEmptyValues: true },
                    persistent: true,
                  })
                )
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoDataWithShowEmptyValuesDoq = connect(
  NoDataWithShowEmptyValuesDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
